<template>
    <div :class="classNameToUse" v-if="groupList.length > 0">
        <app-card-for-group v-for="group in groupList" :key="group.id" :group="group"></app-card-for-group>
    </div>
    <div class="hero is-dark is-medium is-bold" v-else>
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Hello !
                </h1>
                <h2 class="subtitle">
                    There are no groups defined. Start by defining groups of objects.
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import CardForGroup from '../components/main/CardForGroup';

  export default {
    name: "screen-main",
    components: {
      appCardForGroup: CardForGroup
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters('auth', ['isAuth']),
      ...mapGetters('ui', ['screenType']),
      ...mapGetters('objects', ['groupsByBoardId']),
      groupList() {
        return this.groupsByBoardId(1).filter(item => {
          return item.items.length > 0;
        });
      },
      classNameToUse() {
        return `cards ${this.screenType}`;
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
    .cards {
        display: flex;
        flex-wrap: wrap;
    }

    .cards > * {
        min-width: 270px;
        flex-shrink: 0;
        flex-grow: 1;
        margin-right: 0.5rem;
        margin-bottom: 0.75rem;
    }

    @media all and (min-width: 768px) {
        .cards > * {
            flex-shrink: 0.5;
        }
    }

    @media all and (min-width: 1024px) {
        .cards > * {
            flex-shrink: 0.3;
        }
    }
</style>